import { createSlice } from "@reduxjs/toolkit";

const initialState: any = {
    isLoggedIn: false,
    user: null,
};

const userSlice = createSlice({
    name: "userSlice",
    initialState,
    reducers: {
        login(state, action) {
            const { user } = action.payload;
            localStorage.setItem('user', JSON.stringify(user));
            state.isLoggedIn = true;
            state.user = action.payload.user;
        },
        logout(state) {
            localStorage.removeItem('user');
            state.isLoggedIn = false;
            state.user = null;
        },
        loadUserFromStorage(state) {
            const user = localStorage.getItem('user');
            if (user) {
                state.isLoggedIn = true;
                state.user = JSON.parse(user);
            }
        },
    },
});

export const { login, logout, loadUserFromStorage } = userSlice.actions;
export default userSlice.reducer;